export default {
  Excellent: 'Excellent',
  Good: 'Good',
  Error: 'Exception',
  ExcellentTip: 'No critical abnormal events occurred during the current time interval',
  GoodTip: 'A critical abnormal event occurred during the current time interval and has been recovered',
  ErrorTip: 'A critical exception event occurred during the current time interval and was not processed',
  Type: 'Monitoring Type',
  HealthStatus: 'Health status',
  Branch: 'Branch',
  Flow: 'Flow',
  Overview: 'Overview',
  BranchNums: 'Branch numbers',
  ServiceGateway: 'Gateway in service',
  ServiceErrorGateway: 'Gateway for service exceptions',
  ServiceHealthStatus: 'Recent 24-hour service health status',
  AlarmEvent: 'Alert event',
  BusinessIndicators: 'Recent 24-hour business key indicators',
  NetworkMonitor: 'Network Quality Monitoring',
  UpBandwidthPeak: 'Peak upstream bandwidth',
  DownBandwidthPeak: 'Peak downstream bandwidth',
  Delay: 'Delay',
  Jitter: 'Jitter',
  PacketLoss: 'Packet loss',
  BranchHealthStatus: 'Recent 24-hour branch health status',
  BranchFlowTop5: 'Recent 24-hour branch traffic（top5）',
  BusinessDataAnalysis: 'Business data analysis',
  CompareUP: 'Compare to 24 hours ago, data increased',
  CompareDown: 'Compare to 24 hours ago, data reduced',
  CompareUnchange: 'Compare to 24 hours ago, data remains the same',
  ServiceHealthTips1: 'For an overview of common metrics for monitoring service health status as a critical event, which you can use as a reference for alert configuration, go to',
  LastHealthTips: 'more granular monitoring for specific events.', // ServiceHealthTips1 + 告警配置 + ServiceHealthTips2 为一句
  BranchHealthTips1: 'The branch health status is an overview of the common indicators for monitoring branch services, which you can use as a reference for alert configuration, go to',
  BandwidthRateCompareUP: 'Increase in maximum bandwidth utilization (i.e., the ratio of maximum upstream and downstream bandwidth usage to purchased bandwidth) compared to 24-hour-old data',
  BandwidthRateCompareDown: 'Decrease in maximum bandwidth utilization (i.e., the ratio of maximum upstream and downstream bandwidth usage to purchased bandwidth) compared to 24-hour-old data',
  BandwidthRateCompareUnchange: 'The maximum bandwidth utilization (i.e., the ratio of maximum upstream and downstream bandwidth usage to purchased bandwidth) remains unchanged compared to 24-hour-old data',
  BandwidthUsage: 'Maximum bandwidth usage',
  PeakBandwidthUtilizationRateOfUplinkDownlinkLast12h: 'Peak bandwidth utilization rate of uplink/downlink in the last 12h',
}